import requests from "./httpService";

const CarServices = {

    getService: async () => {
        return requests.get(`/service`);
    },
    getVendorActive: async () => {
        return requests.get(`/user/vendor/active`);
    },
    getState: async () => {
        return requests.get(`/newlocation/states`);
    },
    getCities: async (id) => {
        return requests.get(`/newlocation/cities/${id}`);
    },
    getServicePending: async () => {
        return requests.get(`/service?approval_status=Pending`);
    },
    getServiceApprove: async () => {
        return requests.get(`/service?approval_status=Approve`);
    },
    getServiceReject: async () => {
        return requests.get(`/service?approval_status=Reject`);
    },

    getServiceWeb: async () => {
        return requests.get(`/service/landing`);
    },
    updateService: async (id, body) => {
        return requests.patch(`/service/${id}`, body);
    },

    createService: async (body) => {

        return requests.post(`/service`, body);
    },
    deleteService: async (id) => {
        return requests.delete(`/service/${id}`);
    },

    uploadImage: async (body) => {

        return requests.post(`/service/uploadImage`, body);
    },
    removeImage: async (body) => {
        return requests.post(`/service/removeImage`, body);
    },

    updateApprovalStatus: async (id, body) => {
        return requests.patch(`/service/update-approval-status/${id}`, body);
    },

}
export default CarServices;